import styled from 'styled-components'
import moment from '@ambler/moment'
import {Andiv, palette, Text} from '@ambler/andive-next'

const DefaultStyledLogo = styled.div`
  width: 168px;
  height: 38px;
  background-image: url('/static/img/drawer-full-logo.svg');
  background-repeat: no-repeat;
  background-size: 160px 38px;
  background-position-x: 4px;
`

const WinterStyledLogo = styled.div`
  width: 168px;
  height: 38px;
  background-image: url('/static/img/drawer-full-logo_winter.png');
  background-repeat: no-repeat;
  background-size: 160px 38px;
  background-position-x: 4px;
`
const configs = [
  {
    name: 'winter',
    bg: palette.amblea.blue[800],
    fg: palette.amblea.white,
    ranges: [
      ['01-01', '02-01'],
      ['11-01', '12-31'],
    ],
    Component: WinterStyledLogo,
  },
  {
    name: 'default',
    bg: palette.amblea.red[700],
    fg: palette.amblea.white,
    ranges: [['01-01', '12-31']],
    Component: DefaultStyledLogo,
  },
]

export const getStyledLogo = (currentDate: moment.Moment) => {
  for (const config of configs) {
    for (const range of config.ranges) {
      if (currentDate.isBetween(moment(range[0], 'MM-DD'), moment(range[1], 'MM-DD'), 'day', '()')) {
        return config.Component
      }
    }
  }

  return DefaultStyledLogo
}

export function LogoShowcase() {
  return (
    <Andiv column>
      {configs.map(cfg => {
        return (
          <div key={cfg.name} style={{background: cfg.bg}}>
            <Text color={cfg.fg}>{cfg.name}</Text>
            {<cfg.Component />}
            <Text color={cfg.fg}>{cfg.ranges.map(r => '[' + r.join(',') + ']').join(' or ')}</Text>
          </div>
        )
      })}
    </Andiv>
  )
}
